import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UrlStore {
    // These must be unique
    // version should be updated whenever the structure of the filter being saved changes
    public static readonly localStorageKeys = {
        dynamicRateCardMetricsTab1: 'DynamicRateCardMetricTab1',
        dynamicRateCardMetricsTab2: 'DynamicRateCardMetricTab2',
        dynamicRateCardMetricsTab3: 'DynamicRateCardMetricTab3',
        dynamicRateCardMetricsTab4: 'DynamicRateCardMetricTab4',
        dynamicRateCardMetricTab1Order: 'DynamicRateCardMetricTab1Order',
        dynamicRateCardMetricTab2Order: 'DynamicRateCardMetricTab2Order',
        dynamicRateCardMetricTab3Order: 'DynamicRateCardMetricTab3Order',
        dynamicRateCardMetricTab4Order: 'DynamicRateCardMetricTab4Order',

        dynamicRateCardInsightsTab1: 'DynamicRateCardInsightsTab1',
        dynamicRateCardInsightsTab2: 'DynamicRateCardInsightsTab2',
        dynamicRateCardInsightsTab3: 'DynamicRateCardInsightsTab3',
        dynamicRateCardInsightsTab4: 'DynamicRateCardInsightsTab4',
        dynamicRateCardInsightsTab1Order: 'DynamicRateCardInsightsTab1Order',
        dynamicRateCardInsightsTab2Order: 'DynamicRateCardInsightsTab2Order',
        dynamicRateCardInsightsTab3Order: 'DynamicRateCardInsightsTab3Order',
        dynamicRateCardInsightsTab4Order: 'DynamicRateCardInsightsTab4Order',

        politicalRateCardInsights: 'PoliticalRateCardInsights',
        politicalRateCardInsightOrder: 'PoliticalRateCardInsightOrder',
        digitalRateCardInsights: 'DigitalRateCardInsights',
        digitalRateCardInsightOrder: 'DigitalRateCardInsightOrder',
        rateCardMarketOrder: 'RateCardMarketOrder',
        rateCardStationOrder: 'RateCardStationOrder',

        politicalRateCardMetrics: 'PoliticalRateCardMetrics',
        digitalRateCardMetrics: 'DigitalRateCardMetrics',
        politicalRateCardMetricOrder: 'PoliticalRateCardMetricOrder',
        digitalRateCardMetricOrder: 'DigitalRateCardMetricOrder',
        dynamicRateCardSegments: 'DynamicRateCardSegments',
        dynamicRateCardSegmentsTab1: 'DynamicRateCardSegmentsTab1',
        dynamicRateCardSegmentsTab2: 'DynamicRateCardSegmentsTab2',
        dynamicRateCardSegmentsTab3: 'DynamicRateCardSegmentsTab3',
        dynamicRateCardSegmentsTab4: 'DynamicRateCardSegmentsTab4',
        highImpactProgramReportSegments: 'HighImpactProgramReportSegments',
        politicalRateCardSegments: 'PoliticalRateCardSegments',
        digitalRateCardSegments: 'DigitalRateCardSegments',
        dynamicRateCardSegmentsOrder: 'DynamicRateCardSegmentsOrder',
        dynamicRateCardSegmentsTab1Order: 'DynamicRateCardSegmentsTab1Order',
        dynamicRateCardSegmentsTab2Order: 'DynamicRateCardSegmentsTab2Order',
        dynamicRateCardSegmentsTab3Order: 'DynamicRateCardSegmentsTab3Order',
        dynamicRateCardSegmentsTab4Order: 'DynamicRateCardSegmentsTab4Order',
        highImpactProgramReportSegmentsOrder: 'HighImpactProgramReportSegmentsOrder',
        politicalRateCardSegmentsOrder: 'PoliticalRateCardSegmentsOrder',
        digitalRateCardSegmentsOrder: 'DigitalRateCardSegmentsOrder',
        politicalRateCardDemos: 'PoliticalRateCardDemos',
        politicalRateCardDemosOrder: 'PoliticalRateCardDemosOrder',
        inventoryMetricsOrder: 'InventoryMetricsOrder',
        inventoryMetrics: 'InventoryMetrics',
        advertiserMetrics: 'AdvertiserMetrics',
        advertiserMetricsOrder: 'AdvertiserMetricsOrder',
        advertiserStationMetrics: 'AdvertiserStationMetrics',
        dashboardMetrics: 'DashboardMetrics',
        dashboardMetricsOrder: 'DashboardMetricsOrder',
        highImpactDashboardMetrics: 'HighImpactDashboardMetrics',
        highImpactDashboardMetricsOrder: 'HighImpactDashboardMetricsOrder',
        dashboardColumnSortState: 'DashboardColumnSortState',
        rateGeneratorMetrics: 'RateGeneratorMetrics',
        rateGeneratorMetricsOrder: 'RateGeneratorMetricsOrder',
        scenarioUpdateMetrics: 'ScenarioUpdateMetrics',
        scenarioUpdateMetricsOrder: 'ScenarioUpdateMetricsOrder',
        scenarioUpdateMetricsSortState: 'ScenarioUpdateMetricsSortState',
        lurColumns: 'LURColumns',
        lurColumnsOrder: 'LURColumnsOrder',
        lurOrderColumns: 'LUROrderColumns',
        lurOrderColumnsOrder: 'LUROrderColumnsOrder',
        aidaColumns: 'AidaColumns',
        aidaColumnsOrder: 'AidaColumnsOrder',
        ignoredDuplicateSegments: 'IgnoredDuplicateSegments',
    };

    public static readonly screenNames = {
        rateGenerator: 'rate-generator',
        rateCard: 'rate-card',
        politicalRateCard: 'political-rate-card',
        digitalRateCard: 'digital-rate-card',
        advertiserInsights: 'advertiser-insights',
        politicalLur: 'political-lur',
        inventoryInsights: 'inventory-insights',
        dashboard: 'dashboard',
        scenarioPlanning: 'scenario-planning',
        bulkRates: 'bulk-rates',
        admin: {
            userConfig: 'user-config',
            rateOptics: 'rate-optics',
            emailedReport: 'emailed-report',
        },
        aida: 'aida',
        highImpactProgramReport: 'high-impact-program-report',
        proposalPro: 'proposal-pro',
    };

    public static readonly rateCardScreens = [
        UrlStore.screenNames.rateCard,
        UrlStore.screenNames.politicalRateCard,
        UrlStore.screenNames.digitalRateCard,
    ];

    public static readonly ui = {
        landing: '/',
        login: 'login',
        loginError: 'login/error',
        loginUserNotConfigured: 'login/userNotConfigured',
        loginPendingReview: 'login/pendingReview',
        switchCustomer: 'login/switch',
        accessDenied: 'accessDenied',
        documentation: 'documentation',
        admin: {
            base: 'admin',
            rateOpticsAdmin: 'admin/RateOptics',
            rateOpticsUserManagement: 'admin/RateOptics/userManagement',
            rateOpticsSettings: 'admin/RateOptics/settings',
            segmentsManagement: 'admin/SegmentsManagement',
            removeChannels: 'admin/remove-channels',
            updateStatus: 'admin/UpdateStatus',
            roleConfigV2: 'admin/RoleConfigV2',
            config: 'admin/Config',
            editWhitelist: 'admin/EditWhitelist',
            emailAlias: 'admin/EmailAlias',
            userActivityReport: 'admin/UserActivityReport',
            about: 'admin/About',
            emailedReport: 'admin/EmailedReport',
            politicalDayparts: 'admin/PoliticalDayparts',
            dynamicRateCardDayparts: 'admin/DynamicRateCardDayparts',
            aida: 'admin/Aida',
        },
        rateOptics: {
            base: 'RateOptics',
            rateCard: 'RateOptics/DynamicRateCard',
            rateCardV2: 'RateOptics/PricingHub',
            dashboard: 'RateOptics/Dashboard',
            rateGenerator: 'RateOptics/RateGenerator',
            politicalLUR: 'RateOptics/PoliticalLUR',
            advertiserInsights: 'RateOptics/AdvertiserInsights',
            inventoryInsights: 'RateOptics/InventoryInsights',
            ratePerformance: 'RateOptics/RatePerformance',
            highImpactProgramReport: 'RateOptics/HighImpactProgramReport',
            bulkRates: 'RateOptics/BulkRates',
            aida: 'RateOptics/Aida',
            aidaChat: 'RateOptics/Aida/Chat',
            proposalChat: 'RateOptics/Aida/Proposal/Chat',
            proposalPro: 'RateOptics/ProposalPro',
            proposalProNew: 'RateOptics/ProposalPro/New',
            proposalProNewSource: 'RateOptics/ProposalPro/New/Source',
            proposalProNewClone: 'RateOptics/ProposalPro/New/Clone',
            proposalProNewRfp: 'RateOptics/ProposalPro/New/RFP',
            proposalProNewImport: 'RateOptics/ProposalPro/New/Import',
            proposalProNewDetails: 'RateOptics/ProposalPro/New/Details',
            proposalProNewDesign: 'RateOptics/ProposalPro/New/Design',
            proposalProNewAi: 'RateOptics/ProposalPro/New/AI',
            proposalProNewChat: 'RateOptics/ProposalPro/New/Chat',
            proposalProBuilder: 'RateOptics/ProposalPro/Builder',
            reportAssistant: 'RateOptics/ReportAssistant',
            reportStudio: 'RateOptics/ReportStudio',
        },
    };

    public static readonly api = {
        config: `${environment.api}/v1/config`,
        zendeskToken: `${environment.api}/v1/integration/zendesk-token`,
        lookupsV2: {
            period: `${environment.api}/v2/lookups/period`,
            dow: `${environment.api}/v2/lookups/dow`,
            pricingTiers: `${environment.api}/v2/lookups/pricing-tiers`,
            spotTypes: `${environment.api}/v2/lookups/spot-types`,
            newSpotTypes: `${environment.api}/v2/lookups/new-spot-types`,
            categories: `${environment.api}/v2/lookups/categories`,
            products: `${environment.api}/v2/lookups/ratecard/digital-products`,
            productTypes: `${environment.api}/v2/lookups/ratecard/digital-product-types`,
            specialEventTypes: `${environment.api}/v2/lookups/ratecard/event-types`,
            savedReport: `${environment.api}/v2/lookups/saved-report`,
            sharedReport: `${environment.api}/v2/lookups/shared-report`,
            saveEmailReportFrequency: `${environment.api}/v2/lookups/save-email-report-frequency`,
            sendOneTimeReport: `${environment.api}/v2/lookups/send-one-time-report`,
            emailSavedReport: `${environment.api}/v2/lookups/email-saved-report`,
            saveEmailReportUsers: `${environment.api}/v2/lookups/save-email-report-users`,
            filter: `${environment.api}/v2/lookups/filter`,
            filters: `${environment.api}/v2/lookups/filters`,
            priorityCodes: `${environment.api}/v2/lookups/priority_codes`,
            markets: `${environment.api}/v2/lookups/markets`,
            pCodeMarkets: `${environment.api}/v2/lookups/p-code-markets`,
            stations: `${environment.api}/v2/lookups/stations`,
            pCodeStations: `${environment.api}/v2/lookups/p-code-stations`,
            channels: `${environment.api}/v2/lookups/channels`,
            pCodeChannels: `${environment.api}/v2/lookups/p-code-channels`,
            channelGroups: `${environment.api}/v2/lookups/channel-groups`,
            dayparts: `${environment.api}/v2/lookups/dayparts`,
            asOfDatesV2: `${environment.api}/v2/lookups/dates`,
            rateExpirationDate: `${environment.api}/v2/lookups/rate-expiration-date`,
            customerLogo: `${environment.api}/v2/lookups/customer-logo`,
            autoPublish: `${environment.api}/v2/lookups/auto-publish`,
            rateCardPeriods: `${environment.api}/v2/lookups/rate-card-period`,
            politicalWindow: `${environment.api}/v2/lookups/political-windows`,
            allPoliticalWindow: `${environment.api}/v2/lookups/all-political-windows`,
            politicalInitAllTiers: `${environment.api}/v2/lookups/political-initialization-all-tiers`,
            politicalInitPoliticalTiers: `${environment.api}/v2/lookups/political-initialization-political-tiers`,
            politicalInitTiersHistory: `${environment.api}/v2/lookups/political-initialization-tiers-history`,
            politicalSettings: `${environment.api}/v2/lookups/political-settings`,
            stationExceptions: `${environment.api}/v2/lookups/station-exceptions`,
            digitalPricingTiers: `${environment.api}/v2/lookups/digital-pricing-tiers`,
            dynamicPricingTiers: `${environment.api}/v2/lookups/dynamic-pricing-tiers`,
            userSavedReportAccess: `${environment.api}/v2/lookups/user-saved-report-access`,
            reportUsers: `${environment.api}/v2/lookups/report-users`,
            timezones: `${environment.api}/v2/lookups/timezones`,
            hipCustomGroups: `${environment.api}/v2/lookups/hip-custom-groups`,
            hipCustomGroupsBatch: `${environment.api}/v2/lookups/hip-custom-groups/batch`,
            hipSaveWithAIGroups: `${environment.api}/v2/lookups/hip-save-with-ai-groups`,
        },
        ratePerformance: {
            quicksight: `${environment.api}/v2/rate-performance/quicksight-dashboard`,
        },
        userActivity: {
            quicksight: `${environment.api}/v1/user-activity/quicksight-dashboard`,
        },
        rateCardLookupsV2: {
            segments: `${environment.api}/v3/ratecard/segments`,
            addRowPopupSegments: `${environment.api}/v3/ratecard/add-row-segments`,
            dowSegments: `${environment.api}/v3/ratecard/dow-segments`,
            politicalSegments: `${environment.api}/v3/ratecard/political/segments`,
            rateCardMetricTypes: `${environment.api}/v2/ratecard/dynamic/metric-types`,
            politicalRateCardMetricTypes: `${environment.api}/v2/ratecard/political/metric-types`,
            digitalRateCardMetricTypes: `${environment.api}/v2/ratecard/digital/metric-types`,
            roundingRules: `${environment.api}/v3/ratecard/rounding-rules`,
            moduleConfig: `${environment.api}/v2/ratecard/module-config`,
            defaultReport: `${environment.api}/v2/ratecard/default-report`,
            enabledRatecards: `${environment.api}/v2/ratecard/enabled-ratecards`,
            priorityCodeTiers: `${environment.api}/v2/ratecard/priority-code-tiers`,
            priorityCodeStationsQuartersInitialized: `${environment.api}/v2/ratecard/initialized-priority-code-stations-quarters`,
            quarters: `${environment.api}/v2/ratecard/quarters`,
            reorderSegments: `${environment.api}/v2/ratecard/reorder-segments`,
            resetReorderSegments: `${environment.api}/v2/ratecard/reset-reorder-segments`,
            systemSegments: `${environment.api}/v1/ratecard/system-segment`,
            systemSegmentsAiredWeeks: `${environment.api}/v2/ratecard/segment-aired-weeks`,
            dynamicMetricFavorite: `${environment.api}/v2/ratecard/dynamic/favorite-metric`,
            politicalMetricFavorite: `${environment.api}/v2/ratecard/political/favorite-metric`,
            digitalMetricFavorite: `${environment.api}/v2/ratecard/digital/favorite-metric`,
        },
        digital: {
            segments: `${environment.api}/v3/ratecard/digital/segments`,
        },
        customDaypart: {
            customDaypart: `${environment.api}/v1/custom-daypart`,
            customDaypartAll: `${environment.api}/v1/custom-daypart/all`,
            customDaypartAccessForUser: `${environment.api}/v1/custom-daypart/daypart-user-access`,
        },
        advertiserInsightsLookups: {
            advertiserInsightsCascadingFilters: `${environment.api}/v1/advertiser-insights/cascading-filters`,
            advertisers: `${environment.api}/v1/advertiser-insights/advertisers`,
            advertisersCount: `${environment.api}/v1/advertiser-insights/advertisers-count`,
            agencies: `${environment.api}/v1/advertiser-insights/agencies`,
            priorityCodes: `${environment.api}/v1/advertiser-insights/priority-codes`,
            orderCategories: `${environment.api}/v1/advertiser-insights/order-categories`,
            orderDemographics: `${environment.api}/v1/advertiser-insights/order-demographics`,
            orderDetailOptions: `${environment.api}/v1/advertiser-insights/order-detail-options`,
            orderAEs: `${environment.api}/v1/advertiser-insights/account-executives`,
        },
        advertiserInsights: {
            advertiserInsights: `${environment.api}/v1/advertiser-insights`,
            orders: `${environment.api}/v1/advertiser-insights/orders`,
            alerts: `${environment.api}/v1/advertiser-insights/alerts`,
        },
        inventoryInsights: {
            inventoryInsightsV2: `${environment.api}/v2/inventory-insights`,
            metricsV2: `${environment.api}/v2/inventory-insights/metrics`,
        },
        inventoryInsightsLookups: {
            segments: `${environment.api}/v3/inventory-insights/segments`,
            spotLengths: `${environment.api}/v1/inventory-insights/spot-lengths`,
            spotTypes: `${environment.api}/v1/inventory-insights/spot-types`,
            newSpotTypes: `${environment.api}/v1/inventory-insights/new-spot-types`,
            spotTypesV2: `${environment.api}/v2/inventory-insights/spot-types`,
            metricFavorite: `${environment.api}/v2/inventory-insights/favorite-metric`,
        },
        specialEventsV2: {
            specialEvents: `${environment.api}/v2/special-events/events`,
            specialEventType: `${environment.api}/v2/special-events/event-type`,
            segments: `${environment.api}/v3/special-events/segments`,
        },
        rateCard: {
            rateCardV2: `${environment.api}/v2/ratecard/dynamic`,
            rateCardV2Advertisers: `${environment.api}/v2/ratecard/dynamic/advertisers`,
            sportRateCardV2: `${environment.api}/v2/ratecard/sport`,
            segmentSubtitle: `${environment.api}/v2/ratecard/segment-subtitle`,
            asyncTriggerLoadRateCardV2: `${environment.api}/v2/ratecard/dynamic-rate-card/async-load`,
            digitalRateCard: `${environment.api}/v2/ratecard/digital`,
            politicalRateCardV2: `${environment.api}/v2/ratecard/political`,
            sportPoliticalRateCardV2: `${environment.api}/v2/ratecard/sport-political`,
            asyncLoadPoliticalRateCardV2: `${environment.api}/v2/ratecard/political-rate-card/async-load`,
            overridesV2: `${environment.api}/v2/ratecard/dynamic/overrides`,
            politicalOverridesV2: `${environment.api}/v2/ratecard/political/overrides`,
            digitalOverridesV2: `${environment.api}/v2/ratecard/digital/overrides`,
            alerts: `${environment.api}/v1/ratecard/metric-alerts`,
            tierSettings: `${environment.api}/v1/ratecard/pricing-tiers`,
            hiddenSegments: `${environment.api}/v1/ratecard/hidden-segments`,
            userSegment: `${environment.api}/v2/ratecard/user-segment`,
            mergeSegment: `${environment.api}/v2/ratecard/merge-segment`,
            mergedSegment: `${environment.api}/v2/ratecard/merged-segment`,
            bulkUserSegment: `${environment.api}/v2/ratecard/bulk-user-segment`,
            bulkUserOneTimeSegment: `${environment.api}/v2/ratecard/bulk-user-onetime-segment`,
            digitalTierSettings: `${environment.api}/v1/ratecard/digital-pricing-tiers`,
            politicalRateCardSpotLengths: `${environment.api}/v1/ratecard/political-spot-lengths`,
            pCodeTierSettings: `${environment.api}/v1/ratecard/pcode-pricing-tiers`,
            politicalCascadeFactors: `${environment.api}/v1/ratecard/political-cascade-factors`,
            createQuarterlyRateCard: `${environment.api}/v2/ratecard/create-quarterly-rate-card`,
            reinitializeQuarterlyRateCard: `${environment.api}/v2/ratecard/reinitialize-quarterly-rate-card`,
            initializePoliticalRateCard: `${environment.api}/v3/ratecard/initialize-political-rate-card`,
            reinitializePoliticalRateCard: `${environment.api}/v3/ratecard/reinitialize-political-rate-card`,
            bulkDRAllocations: `${environment.api}/v1/ratecard/bulk-dr-allocations`,
        },
        rateCardUpload: {
            preview: `${environment.api}/v1/rate-card-upload/preview`,
            confirm: `${environment.api}/v1/rate-card-upload/confirm`,
        },
        politicalLURV2: {
            politicalLUR: `${environment.api}/v2/political-lur`,
            orders: `${environment.api}/v2/political-lur/orders`,
            politicalRate: `${environment.api}/v2/political-lur/political-rate`,
            politicalWindow: `${environment.api}/v2/political-lur/political-window`,
            segments: `${environment.api}/v3/political-lur/segments`,
            spotLengths: `${environment.api}/v2/political-lur/spot-lengths`,
        },
        rateGen: {
            metrics: `${environment.api}/v1/rategen/metrics`,
            surveyBooks: `${environment.api}/v1/rategen/survey-books`,
            spotLengths: `${environment.api}/v1/rategen/spot-lengths`,
        },
        rateGenV2: {
            rateGen: `${environment.api}/v2/rategen`,
            demographics: `${environment.api}/v2/rategen/demographics`,
        },
        rateGenV3: {
            reorderDayparts: `${environment.api}/v3/rategen/reorder-dayparts`,
        },
        rateGenV4: {
            rateGen: `${environment.api}/v4/rategen`,
            otherMetrics: `${environment.api}/v4/rategen/other-metrics`,
        },
        woms: {
            uploadV2: `${environment.api}/v2/export/woms/mapping`,
            ratesV2: `${environment.api}/v2/export/woms/rates`,
            programsV2: `${environment.api}/v2/export/woms/programs`,
            autoMapStream: `${environment.api2}/stream/woms/auto-map`,
        },
        admin: {
            metricAlerts: `${environment.api}/v1/admin/metric-alerts`,
            metricAlertsDisplayOrder: `${environment.api}/v1/admin/metric-alerts-display-order`,
            pricingSettings: `${environment.api}/v1/admin/pricing-settings`,
            tierManagement: `${environment.api}/v1/admin/tier-management`,
            tierManagementV2: `${environment.api}/v2/admin/tier-management`,
            priorityCodeMappings: `${environment.api}/v1/admin/priority-code-mappings`,
            politicalTiers: `${environment.api}/v1/admin/political-tiers`,
            quicksight: `${environment.api}/v1/admin/quicksight`,
            politicalWindows: `${environment.api}/v1/admin/political-windows`,
            politicalWindowsV2: `${environment.api}/v2/admin/political-windows`,
            priorityCodeTiers: `${environment.api}/v1/admin/priority-code-tiers`,
            priorityCodeTiersV2: `${environment.api}/v2/admin/priority-code-tiers`,
            priorityCodeTiersQuarters: `${environment.api}/v1/admin/priority-code-tiers/quarters`,
            priorityCodeTiersRename: `${environment.api}/v1/admin/priority-code-tiers/rename`,
            politicalWindowsReset: `${environment.api}/v1/admin/political-windows/reset`,
            politicalSettingsUpdate: `${environment.api}/v1/admin/political-mappings`,
            revenueCodes: `${environment.api}/v1/admin/revenue-codes`,
            lurExclusionInclusion: `${environment.api}/v1/admin/lur-exclusion-inclusions`,
            orderType: `${environment.api}/v1/admin/order-type`,
            lurExclusionInclusionAdvertisers: `${environment.api}/v1/admin/lur-exclusion-inclusions/advertisers`,
            lurExclusionInclusionAgencies: `${environment.api}/v1/admin/lur-exclusion-inclusions/agencies`,
        },
        userAdmin: {
            config: `${environment.api}/v1/user-admin/config`,
            appUser: `${environment.api}/v1/user-admin/user`,
            userRoles: `${environment.api}/v1/user-admin/lookups/user-roles`,
            vapid: `${environment.api}/v1/user-admin/vapid`,
            stations: `${environment.api}/v1/user-admin/lookups/stations`,
            channels: `${environment.api}/v1/user-admin/lookups/channels`,
            trafficAEs: `${environment.api}/v1/user-admin/lookups/account-executives`,
            userMarkets: `${environment.api}/v1/user-admin/lookups/user-markets`,
            userStations: `${environment.api}/v1/user-admin/lookups/user-stations`,
            userChannels: `${environment.api}/v1/user-admin/lookups/user-channels`,
            users: `${environment.api}/v1/user-admin/users/adv`,
            userAdvertisersAccess: `${environment.api}/v1/user-admin/user/adv`,
            userAdvertisersNoAccess: `${environment.api}/v1/user-admin/user/adv/unassigned`,
            emailedReport: `${environment.api}/v2/admin/emailed-report`,
        },
        internalAdmin: {
            roleConfigOverrideable: `${environment.api}/v2/internal-admin/user-role/metric-overrides`,
            roleConfigMetricsOverrideable: `${environment.api}/v2/internal-admin/user-role/metrics-overrideable-by-role`,
            roleConfigV2: `${environment.api}/v2/internal-admin/user-role-v2/config`,
            roleConfigMetricsV2: `${environment.api}/v2/internal-admin/user-role-v2/metrics`,
            roleConfigOverrideableV2: `${environment.api}/v2/internal-admin/user-role-v2/metric-overrides`,
            roleConfigMetricsOverrideableV2: `${environment.api}/v2/internal-admin/user-role-v2/metrics-overrideable-by-role`,
            roleConfigPricingTiersV2: `${environment.api}/v2/internal-admin/user-role-v2/pricing-tiers`,
            roleConfigDigitalPricingTiersV2: `${environment.api}/v2/internal-admin/user-role-v2/digital-pricing-tiers`,
            userRole: `${environment.api}/v2/internal-admin/user-role`,
            cloneUserRole: `${environment.api}/v2/internal-admin/user-role/clone`,
            whitelist: `${environment.api}/v2/internal-admin/user-role/whitelist`,
            channelUpdateStatus: `${environment.api}/v2/internal-admin/channel-status/update-status`,
            triggerApp: `${environment.api}/v2/internal-admin/channel-status/trigger-app`,
            triggerAppForNewChannel: `${environment.api}/v2/internal-admin/channel-status/trigger-app-new-channel`,
            refreshAppStatus: `${environment.api}/v2/internal-admin/channel-status/refresh-app`,
            triggerAPPStepFunction: `${environment.api}/v2/internal-admin/channel-status/trigger-app-step-function`,
            deleteChannel: `${environment.api}/v2/internal-admin/channel-status/delete`,
            customerConfig: `${environment.api}/v2/internal-admin/customer-config`,
            customerMetric: `${environment.api}/v2/internal-admin/customer-config/metric`,
            customerRatecardMetric: `${environment.api}/v2/internal-admin/customer-config/ratecard-metric`,
            moduleConfig: `${environment.api}/v2/internal-admin/module-config`,
            channelConfig: `${environment.api}/v2/internal-admin/channel-config`,
            channelGroupConfig: `${environment.api}/v2/internal-admin/channel-group-config`,
            ratecardMetricGroup: `${environment.api}/v2/internal-admin/customer-config/ratecard-metric-group`,
            hiddenSegments: `${environment.api}/v2/internal-admin/segments/hidden`,
            editedSegments: `${environment.api}/v2/internal-admin/segments/edited`,
            addedSegments: `${environment.api}/v2/internal-admin/segments/added`,
            politicalBoundConfig: `${environment.api}/v2/internal-admin/political-bound-config`,
            politicalBoundConfigOptions: `${environment.api}/v2/internal-admin/political-bound-config/political-bound-config-options`,
            moduleConfigDayparts: `${environment.api}/v2/internal-admin/module-config/dayparts`,
            politicalDayparts: `${environment.api}/v2/internal-admin/political-dayparts`,
            dynamicRateCardDayparts: `${environment.api}/v2/internal-admin/dynamic-rate-card-dayparts`,
            unmatchedLogins: `${environment.api}/v2/internal-admin/email-alias/unmatched-logins`,
            resolveUnmatchedLogin: `${environment.api}/v2/internal-admin/email-alias/unmatched-logins/resolve`,
            dismissUnmatchedLogin: `${environment.api}/v2/internal-admin/email-alias/unmatched-logins/dismiss`,
            emailAliases: `${environment.api}/v2/internal-admin/email-alias/aliases`,
            deleteEmailAlias: `${environment.api}/v2/internal-admin/email-alias/aliases/delete`,
        },
        dashboard: {
            dashboardV3: `${environment.api}/v3/dashboard`,
            scenario: `${environment.api}/v3/dashboard/scenario`,
            nationalPlanning: `${environment.api}/v3/dashboard/national-planning`,
            aduPlanning: `${environment.api}/v3/dashboard/adu-planning`,
            drScenarios: `${environment.api}/v3/dashboard/dr-scenarios`,
            impactNetOut: `${environment.api}/v3/dashboard/impact-net-out`,
            scenarioLiability: `${environment.api}/v3/dashboard/scenario-liability`,
            publishScenario: `${environment.api}/v3/dashboard/publish-scenario`,
            quicksight: `${environment.api}/v3/dashboard/quicksight-dashboard`,
            budgetPlanner: `${environment.api}/v3/dashboard/budget-planner`,
            budgetPlannerDrill: `${environment.api}/v3/dashboard/budget-planner/drill`,
            budgetPlannerPlan: `${environment.api}/v3/dashboard/budget-planner/plan`,
            budgetPlannerFlags: `${environment.api}/v3/dashboard/budget-planner/flags`,
            budgetPlannerAdjustments: `${environment.api}/v3/dashboard/budget-planner/adjustments`,
        },
        dashboardLookups: {
            aggTypes: `${environment.api}/v1/dashboard/agg-types`,
            monthYears: `${environment.api}/v1/dashboard/month-years`,
            revenueCategories: `${environment.api}/v1/dashboard/revenue-categories`,
            dayparts: `${environment.api}/v1/dashboard/dayparts`,
        },
        specification: {
            specificationV2: `${environment.api}/v2/specification`,
        },
        bulkRates: {
            bulkRates: `${environment.api}/v2/bulk-rates`,
        },
        aida: {
            aida: `${environment.api}/v2/aida`,
            proposal: `${environment.api}/v2/aida/proposal`,
            proposalHtml: `${environment.api}/v2/aida/proposal-html`,
            proposalChat: `${environment.api2}/v2/aida/proposal-chat`,
            stationChat: `${environment.api2}/v2/aida/station-chat`,
            proposalChatStream: `${environment.api2}/stream/v2/aida/proposal-chat`,
            stationChatStream: `${environment.api2}/stream/v2/aida/station-chat`,
            createProposal: `${environment.api}/v2/aida/create-proposal`,
            proposalInsights: `${environment.api}/v2/aida/proposal-insights`,
            salesperson: `${environment.api}/v2/aida/salesperson`,
            advertisers: `${environment.api}/v2/aida/advertisers`,
            agencies: `${environment.api}/v2/aida/agencies`,
            mapAgency: `${environment.api}/v2/aida/map-agency`,
            mapAdvertiser: `${environment.api}/v2/aida/map-advertiser`,
            mapSalesperson: `${environment.api}/v2/aida/map-salesperson`,
            xml: `${environment.api}/v2/aida/xml`,
            delete: `${environment.api}/v2/aida/delete`,
            triggerProposal: `${environment.api}/v2/aida/trigger-proposal`,
        },
        highImpactProgramReport: {
            getHighImpactProgramReport: `${environment.api}/v1/high-impact-report`,
            loadExistingHighImpactReports: `${environment.api}/v1/high-impact-report/reports`,
            hipReportGroupOrder: `${environment.api}/v1/high-impact-report/group-order`,
            saveWhatIfOverrides: `${environment.api}/v1/high-impact-report/what-if-overrides`,
            earliestDataDate: `${environment.api}/v1/high-impact-report/earliest-date`,
        },
        reportStudio: { reports: `${environment.api}/v1/report-studio/reports` },
        cablenetReport: {
            chatStream: `${environment.api2}/stream/v2/cablenet-report/chat`,
            chats: `${environment.api}/v1/cablenet-report/chats`,
        },
        hipReportGenerate: {
            proposeStream: `${environment.api2}/stream/v2/hip-report-generate/propose`,
        },
        proposalPro: {
            builderMode: (proposalId: number) => `${environment.api}/v1/proposal-pro/proposal/${proposalId}/builder-mode`,
            proposals: `${environment.api}/v1/proposal-pro/proposal`,
            cloneFromOrder: `${environment.api}/v1/proposal-pro/proposal/clone-from-order`,
            importXml: `${environment.api}/v1/proposal-pro/proposal/import-xml`,
            importXmlParse: `${environment.api}/v1/proposal-pro/proposal/import-xml/parse`,
            line: `${environment.api}/v1/proposal-pro/proposal/line`,
            flight: `${environment.api}/v1/proposal-pro/proposal/flight`,
            chat: `${environment.api2}/v1/proposal-pro/proposal`,
            chatStream: `${environment.api2}/stream/v2/proposal-pro/proposal`,
            aiBuilder: {
                build: `${environment.api2}/v1/proposal-pro/ai-builder/build`,
                buildStream: `${environment.api2}/stream/v2/proposal-pro/ai-builder/build`,
            },
            greenLoop: {
                buildStream: `${environment.api2}/stream/v2/proposal-pro/green-loop/build`,
            },
            assistant: {
                chatStream: `${environment.api2}/stream/v2/proposal-pro/assistant/chat`,
                sessions: `${environment.api}/v1/proposal-pro/assistant/sessions`,
            },
            // Long-running PDF/PPTX export - routed to streaming Lambda to
            // escape API Gateway's 30s timeout. Still returns a binary file,
            // not SSE.
            exportStream: `${environment.api2}/stream/v2/proposal-pro/proposal`,
            designBuildStream: `${environment.api2}/stream/v2/proposal-pro/proposal/design-build`,
            rfp: {
                parse: `${environment.api2}/v1/proposal-pro/rfp/parse`,
                generatePlans: `${environment.api}/v1/proposal-pro/rfp/generate-plans`,
                createProposal: `${environment.api}/v1/proposal-pro/rfp/create-proposal`,
            },
            lookups: {
                // Advertiser/agency dropdowns use the shared Advertiser Insights
                // lookups (`api.advertiserInsightsLookups`) — see
                // PROPOSAL_PRO_LOOKUP_PARAMS.
                orderLookbook: `${environment.api}/v1/proposal-pro/lookups/order-lookbook`,
                orderLookbookSummary: `${environment.api}/v1/proposal-pro/lookups/order-lookbook-summary`,
                roRatesStream: `${environment.api2}/stream/v2/proposal-pro/lookups/ro-rates`,
                customDaypartForWindow: `${environment.api}/v1/proposal-pro/lookups/custom-daypart-for-window`,
                daypartWindows: `${environment.api}/v1/proposal-pro/lookups/daypart-windows`,
            },
        },
    };

    constructor() {}
}
